import type {
  KnownLocaleCodes,
  LocaleAliasCodes,
  SupportedLocaleCodes,
} from './constants'
import { LOCALE_ALIASES, SUPPORTED_LOCALES } from './constants'

export { normalizeLng, simpleLocalizeLoadPath } from 'pixai-utils/i18n'

/**
 * Parse locale from pathname.
 * Extracts the first segment and resolves it (through alias normalization)
 * to a supported locale, or `undefined` if it isn't a locale segment.
 */
export function getLocaleFromPathname(
  pathname: string,
): SupportedLocaleCodes | undefined {
  const firstSegment = pathname.split('/')[1]?.toLowerCase()
  if (!firstSegment) return undefined
  return normalizeLocale(firstSegment) ?? undefined
}

export function normalizeLocale(locale: unknown): SupportedLocaleCodes | null {
  if (isSupportedLocale(locale)) return locale
  if (isLocaleAlias(locale)) return LOCALE_ALIASES[locale]
  return null
}

export function isSupportedLocale(
  input: unknown,
): input is SupportedLocaleCodes {
  if (typeof input !== 'string') return false
  return Object.hasOwn(SUPPORTED_LOCALES, input)
}

export function isLocaleAlias(input: unknown): input is LocaleAliasCodes {
  if (typeof input !== 'string') return false
  return Object.hasOwn(LOCALE_ALIASES, input)
}

export function isKnownLocale(input: unknown): input is KnownLocaleCodes {
  return isLocaleAlias(input) || isSupportedLocale(input)
}
